// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__EVMnC","loaderOuter":"PageOverlayLoader_loaderOuter__1CBkQ"};